import PropTypes from "prop-types";
export const HighlightedComponentPropType = PropTypes.shape({
  component_id: PropTypes.string,
  step_number: PropTypes.number,
  hed: PropTypes.string,
  dek: PropTypes.string,
  arrow_position: PropTypes.string,
});
